import { ProfileNavbarInterface } from '@type/header-types';
import { useTranslation } from 'next-i18next';
import { dataTestId } from '@services/data-test-id';
import { NeuroIcon } from '@components/common/Icons';
import { composeProfileTextClasses } from './_profileNavbarStyles';
import { ProfileAvatar } from './ProfileAvatar';
/**
 * @description Renders the profile with image, name, email and score. Used in the navbar or
 * somewhere else if needed.
 * * **headerInfo** The header info data
 * * **size** The size of the profile image
 * * **className** Extra classes
 */
export const ProfileInNavbar = (props: ProfileNavbarInterface) => {
  // Component props
  const { headerInfo, size = 'sm', className } = props;
  // translate
  const { t } = useTranslation('common');
  // Classes
  // ******************************************
  const nameClasses = composeProfileTextClasses(size, 'name');
  // Data aliases
  // ******************************************
  const isCompany = headerInfo?.hasBusinessWallet;
  const name = isCompany ? headerInfo?.name || t('account.label.myaccount') : headerInfo?.candidateName || t('account.label.myaccount');
  // Render component
  // Short-circuit if the headerInfo is null
  // ******************************************
  if (!headerInfo) return (<></>);
  return (
    <span
      className={`flex items-center gap-3 ${className || ''}`}
      {...dataTestId('navbar.profile')}
    >
      {/* Avatar */}
      <ProfileAvatar headerInfo={headerInfo} className="md:hidden" />
      {/* User info; accounts created with the phone number don't have an email address initially */}
      <span className="relative hidden items-center lg:flex">
        <span className={nameClasses}>{name}</span>
        {/* Wallet balance badge — the navbar wallet icon moved into the account menu, so the
            balance stays glanceable here, superscript-style over the name's top right. */}
        <span className="absolute -right-3 -top-2.5 flex items-center gap-0.5 rounded-full bg-secondary/15 px-1 py-px text-[10px] font-bold leading-tight text-secondary">
          {headerInfo?.walletCredits ?? 0}
          <NeuroIcon className="size-1.5" />
        </span>
      </span>
    </span>
  );
};
